import React from 'react';

const Copyright = () => {
    return (
        <div className="copy-right-section">
            ©
            <script>
                document.write(new Date().getFullYear());
            </script>
            All Rights Reserved- Customs Bond Commissionerate (CBC)
        </div>
    );
};

export default Copyright;
